import { createContext, useContext } from 'react';

// Maps an EbookChapter block id -> { anchor, number } so chapter blocks can render
// their auto-computed number and anchor consistently with the sidebar TOC.
const EbookChaptersContext = createContext({});

export const EbookChaptersProvider = EbookChaptersContext.Provider;

export const useEbookChapter = (id) => {
  const map = useContext(EbookChaptersContext);
  return (id != null && map?.[id]) || null;
};

export default EbookChaptersContext;
